import React from "react";

const NumberCircleIcon = ({
  num = 1,
  size = 12,
  fontSize = 8,
  color = "#000",
}) => {
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: `${size}px`,
        height: `${size}px`,
        border: `1px solid ${color}`,
        borderRadius: "50%",
        fontSize: `${fontSize}px`,
        fontWeight: "bold",
        color: color,
      }}
    >
      {num}
    </span>
  );
};

export default NumberCircleIcon;
